import { render, staticRenderFns } from "./AuthButtons.vue?vue&type=template&id=5370af7e&scoped=true&"
import script from "./AuthButtons.vue?vue&type=script&lang=js&"
export * from "./AuthButtons.vue?vue&type=script&lang=js&"
import style0 from "./AuthButtons.vue?vue&type=style&index=0&id=5370af7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5370af7e",
  null
  
)

export default component.exports